export type SurveyStatus = 'upcoming' | 'active' | 'expired';
export type QuestionValue = { text: string; type: string };
export type StatusFilter = 'all' | SurveyStatus;

export type Survey = {
  id: number;
  theme: string;
  description: string;
  date_start: string;
  date_end: string;
  question_count: number;
  response_count: number;
  status: SurveyStatus;
};

export type SurveyStat = {
  id_question: number;
  nbResponse: number;
  question: string | null;
  question_type: string;
};

export type SurveyStatsData = {
  questions: Array<{ id: number; question: string; type: string }>;
  stats: SurveyStat[];
  total_responses: number;
  skipped: number;
};

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(dateStr: string): string {
  return new Date(dateStr).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
